import React from "react";
import '../styles/thanksmessage.css';

const ThanksMessage = () => {
  return (
    <div className="thanks-message">
      <p>Thank you for sending your email! I will message you soon 💓.</p>
    </div>
  );
};

export default ThanksMessage;
